var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "asc__showPage-container" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "header",
                [
                  _c("Breadcrumb", {
                    attrs: { title: _vm.rowData.Description1 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c("section", [
                _c("span", [
                  _c("i", { staticClass: "fas fa-check" }),
                  _vm._v(" "),
                  _c("b", [_vm._v(_vm._s(_vm.$t("insert.status")) + ":")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rowData.StatusId
                          ? _vm.$t("insert.active")
                          : _vm.$t("insert.passive")
                      )
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-code" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.fixedTerm.code")) + ":")
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Code))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fas fa-calendar" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("insert.fixedTerm.period")) + ":")
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Period))
                ]),
                _vm._v(" "),
                _c("span", [
                  _c("i", { staticClass: "fa fa-pencil-alt" }),
                  _vm._v(" "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.$t("insert.fixedTerm.description1")) + ":"
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.rowData.Description1))
                ])
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6a4a95a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6a4a95a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FixedTerm/get.vue
// module id = null
// module chunks = 